import {
  CMD_CONFIGURATION,
  COMPANY_DEDUCTIBLE_STATUS,
  useUserDeductible
} from "#/components/context/user/DeductibleContext"
import { Box, Link, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { QmesLink } from "./QmesLink"

export const DeductibleInfoMessage = (): JSX.Element => {
  const { companyDeductibleStatus, cmdConfiguration } = useUserDeductible()
  const intl = useIntl()

  if (companyDeductibleStatus === COMPANY_DEDUCTIBLE_STATUS.NO_DEDUCTIBLE) {
    return (
      <>
        <Typography>
          <FormattedMessage
            defaultMessage="Based on the information you provided, no deductibles apply to your <link>Carrot funds.</link> This means you can use your funds for eligible expenses right away."
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={"/your-benefit-guide/carrot-funds"} color="inherit">
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
        <Box marginTop={(theme) => theme.spacing(theme.tokens.spacing.xl)}>
          <Typography>
            <FormattedMessage defaultMessage="You'll need to update your insurance information each year when it expires." />
          </Typography>
        </Box>
      </>
    )
  }

  const link = (linkContent: string[]) => <QmesLink>{linkContent}</QmesLink>

  const deductibleInfo = {
    [CMD_CONFIGURATION.MEMBER_AND_PARTNER_COMBINED]: intl.formatMessage(
      {
        defaultMessage:
          "You and your partner need to meet an annual deductible before you can use Carrot funds for <link>qualified medical expenses.</link>"
      },
      { link }
    ),
    [CMD_CONFIGURATION.MEMBER_AND_PARTNER_SEPARATE]: intl.formatMessage(
      {
        defaultMessage:
          "You and your partner need to meet annual deductibles before you can use Carrot funds for <link>qualified medical expenses.</link>"
      },
      { link }
    ),
    [CMD_CONFIGURATION.MEMBER_ONLY]: intl.formatMessage(
      {
        defaultMessage:
          "You need to meet an annual deductible before you can use Carrot funds for <link>qualified medical expenses.</link>"
      },
      { link }
    ),
    [CMD_CONFIGURATION.PARTNER_ONLY]: intl.formatMessage(
      {
        defaultMessage:
          "Your partner needs to meet an annual deductible before they can use Carrot funds for <link>qualified medical expenses.</link>"
      },
      { link }
    )
  }

  return (
    <>
      <Typography>{deductibleInfo[cmdConfiguration]}</Typography>
    </>
  )
}
